import React from 'react'
import Link from 'next/link'
import PAGEURL from '../../constants/PAGEURL'
import Head from 'next/head'
import Image from 'next/image'
import AppContext from '../../components/common/AppContext.js'

class About extends React.Component {

  render () {
    const title = 'About SimplyBuy | Free Snowboard, Ski & Product Pickers'
    const description =
      'SimplyBuy is a free product-picker site. Answer a few questions and get a personalized shortlist—best known for snowboard and ski pickers, plus bindings, boots, bikes, headphones, TVs, and more.'

    return (
      <div className="home home-about-page">
        <Head>
          <title>{title}</title>
          <meta name="description" content={description} />
          <meta property="og:title" content={title} />
          <meta property="og:description" content={description} />
          <meta property="og:url" content="https://simplybuy.io/about" />
        </Head>

        <section className="about-hero">
          <div className="about-hero-inner">
            <div className="about-hero-logo">
              <Image
                src={`/simplybuy-logo.webp`}
                width={260}
                height={52}
                priority={true}
                alt="SimplyBuy"
              />
            </div>
            <h1 className="about-hero-title">About SimplyBuy</h1>
            <p className="about-hero-accent">
              A curated shortlist, built for you
            </p>
          </div>
        </section>

        <div className="home-container about-body">
          <div className="about">
            <p className="about-lead">
              Information is everywhere online, which is great until it isn’t.
              Sitting down to buy without knowing where to start usually means
              hours of videos and reviews without a shorter list. The challenge
              isn’t a lack of information; it’s overload. SimplyBuy’s pickers,
              crafted by industry experts, narrow real options to gear that
              fits how you actually use the product.
            </p>

            <div className="about-highlights">
              <div className="about-highlight">
                <h2>Built for riders first</h2>
                <p>
                  SimplyBuy is best known for its <strong>snowboard picker</strong> and{' '}
                  <strong>ski picker</strong>, which riders on Reddit often share when
                  people ask what board or skis to buy — including threads in{' '}
                  <a
                    href="https://www.reddit.com/r/snowboarding/comments/q81eo9/for_anyone_looking_for_a_new_snowboard_for_the/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    r/snowboarding
                  </a>
                  {' '}and{' '}
                  <a
                    href="https://www.reddit.com/r/skiing/comments/smt0of/still_looking_for_new_skis_this_season_i_made_a/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    r/skiing
                  </a>.
                </p>
              </div>
              <div className="about-highlight">
                <h2>Same idea, more categories</h2>
                <p>
                  The same approach covers snowboard bindings, snowboard boots,
                  mountain bikes, pickleball paddles, headphones, monitors, and TVs.
                </p>
              </div>
            </div>

            <p className="about-disclosure">
              As an Amazon Associate and affiliate for companies such as evo and
              JensonUSA, SimplyBuy may earn a small commission when you purchase
              through recommendation links, at no additional cost to you.
            </p>

            <div className="about-primary-ctas">
              <Link href={PAGEURL.PRODUCT_PICKER('ski', '0')} className="home-primary-cta home-primary-cta--ski">
                Find My Skis
              </Link>
              <Link href={PAGEURL.PRODUCT_PICKER('snowboard', '0')} className="home-primary-cta home-primary-cta--board">
                Find My Snowboard
              </Link>
            </div>

            <div className="psg-container about-pickers pt-none">
              <div className="about-pickers-label">
                Or try another picker
              </div>
              <div className="product-category mt-md">Outdoor/Sports Gear</div>
              <div className="products-flex">
                <div className="product-container">
                  <Link href={PAGEURL.PRODUCT_PICKER('mountain-bike', '0')}>
                    <div className="product-option">Mountain Bikes</div>
                  </Link>
                </div>
                <div className="product-container">
                  <Link href={'/product-picker/pickleball-paddle/0'}>
                    <div className="product-option">Pickleball Paddles</div>
                  </Link>
                </div>
                <div className="product-container">
                  <Link href={'/product-picker/ski/0'}>
                    <div className="product-option">Skis</div>
                  </Link>
                </div>
                <div className="product-container">
                  <Link href={'/product-picker/snowboard/0'}>
                    <div className="product-option">Snowboards</div>
                  </Link>
                </div>
                <div className="product-container">
                  <Link href={'/product-picker/snowboard-binding/0'}>
                    <div className="product-option">Snowboard Bindings</div>
                  </Link>
                </div>
                <div className="product-container">
                  <Link href={PAGEURL.PRODUCT_PICKER('snowboard-boots', '0')}>
                    <div className="product-option">Snowboard Boots</div>
                  </Link>
                </div>
              </div>
              <div className="product-category">Tech</div>
              <div className="products-flex">
                <div className="product-container">
                  <Link href={'/product-picker/headphones/0'}>
                    <div className="product-option">Headphones</div>
                  </Link>
                </div>
                <div className="product-container">
                  <Link href={'/product-picker/monitor/0'}>
                    <div className="product-option">Monitors</div>
                  </Link>
                </div>
                <div className="product-container">
                  <Link href={PAGEURL.BUYANGLE('tv')}>
                    <div className="product-option">TVs</div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

About.contextType = AppContext;

export default About
